import React from "react";
import { GlobeHemisphereWest, ShieldCheck, Crown, SignOut } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export const Header = ({ email, premium, onVerify, onSignOut }) => {
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 border-b border-white/10 bg-[#0B0D17]/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <div className="flex items-center gap-3">
          <img
            src="/wff-logo.png"
            alt="World Franchise Forum"
            className="h-9 w-auto sm:h-10"
            data-testid="site-logo"
          />
        </div>

        <div className="flex items-center gap-3">
          {premium && (
            <span
              data-testid="premium-badge"
              className="hidden items-center gap-1.5 rounded-full border border-amber-400/40 bg-amber-400/10 px-3 py-1.5 text-xs font-semibold text-amber-300 sm:flex"
            >
              <Crown size={14} weight="fill" /> Premium
            </span>
          )}
          {email ? (
            <div className="flex items-center gap-3">
              <span className="hidden items-center gap-1.5 text-sm text-slate-300 sm:flex">
                <ShieldCheck size={16} weight="fill" className="text-emerald-400" />
                <span data-testid="user-email" className="max-w-[160px] truncate">{email}</span>
              </span>
              <Button
                data-testid="sign-out-btn"
                variant="ghost"
                size="sm"
                onClick={onSignOut}
                className="text-slate-400 hover:text-white"
              >
                <SignOut size={16} className="mr-1" /> Sign out
              </Button>
            </div>
          ) : (
            <Button
              data-testid="header-verify-btn"
              onClick={onVerify}
              className="rounded-full bg-blue-600 font-semibold text-white hover:bg-blue-500"
            >
              Verify Email
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};
